// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__39DG3","head":"ProcedureTableInfo_head__1WFFS"};